// extracted by mini-css-extract-plugin
export default {"grid":"Ingredients_grid__YZILN"};